import { Camp } from './types';

/**
 * Get scheduled date IDs for a specific camp from schedules
 */
export const getScheduledDateIds = (campId: string, schedules: any[]): string[] => {
  const scheduledDateIds: string[] = [];

  schedules.forEach(schedule => {
    if (schedule?.scheduled_camps) {
      for (const scheduled of schedule.scheduled_camps) {
        if (String(scheduled.camp.id) === String(campId)) {
          const dateId = String(scheduled.camp_date.id);
          if (!scheduledDateIds.includes(dateId)) {
            scheduledDateIds.push(dateId);
          }
        }
      }
    }
  });

  return scheduledDateIds;
};

/**
 * Get scheduled date IDs for a specific camp from a single schedule
 */
export const getScheduledDateIdsForSchedule = (
  campId: string,
  schedule: any | null
): string[] => {
  const scheduledDateIds: string[] = [];

  if (schedule?.scheduled_camps) {
    for (const scheduled of schedule.scheduled_camps) {
      if (String(scheduled.camp.id) === String(campId)) {
        scheduledDateIds.push(String(scheduled.camp_date.id));
      }
    }
  }

  return scheduledDateIds;
};

/**
 * Sort schedules by creation date (oldest first)
 */
export const sortSchedulesByDate = (schedules: any[]): any[] => {
  return [...schedules].sort((a, b) =>
    new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  );
};

/**
 * Build a map of scheduled date IDs for all camps across all schedules
 */
export const buildScheduledDateIdsMap = (schedules: any[]): Map<string, string[]> => {
  const map = new Map<string, string[]>();

  if (schedules && schedules.length > 0) {
    for (const schedule of schedules) {
      if (schedule?.scheduled_camps) {
        for (const scheduled of schedule.scheduled_camps) {
          const campId = String(scheduled.camp.id);
          const dateId = String(scheduled.camp_date.id);

          if (!map.has(campId)) {
            map.set(campId, []);
          }

          if (!map.get(campId)!.includes(dateId)) {
            map.get(campId)!.push(dateId);
          }
        }
      }
    }
  }

  return map;
};
